import { Column, ColumnConfig } from "@ant-design/plots";
import React, { useMemo } from "react";
import BaseChartHeader from "./BaseChartHeader";
import { BaseChartProps } from "./types";
import "./Bar.scss";
import { translate } from "utils";

const BarChart: React.FC<BaseChartProps> = ({
	className,
	data = [],
	customConfig,
	title,
	xField,
	yField,
	filter,
	updateFilter,
	updateReport,
	alias,
	isShowLegend = false,
	isStack = true,
	seriesField = "type",
	statusList,
}) => {
	const colors = customConfig?.color?.slice().reverse();
	const config: ColumnConfig = useMemo(
		(): ColumnConfig => ({
			legend: isShowLegend,
			data,
			isStack,
			seriesField,
			xField: xField,
			yField: yField,

			xAxis: {
				label: {
					autoHide: true,
					autoRotate: true,
				},
			},
			meta: {
				[yField]: {
					alias: alias,
				},
			},
			...customConfig,
			tooltip: {
				reversed: true,
			}
		}),
		[data],
	);

	return (
		<div className={className}>
			<BaseChartHeader
				title={title}
				filter={filter}
				updateFilter={updateFilter}
				updateReport={updateReport}
			/>

			<div className="header-status-section flex justify-end bar-header-status">
				{statusList?.map((status, index) => (
					<div className="bar-header-status-item" key={index}>
						<div
							className="bar-header-status-item-dot"
							style={{ backgroundColor: colors[index] }}
						>
							&nbsp;
						</div>
						<p>{translate(status)}</p>
					</div>
				))}
			</div>

			<Column {...config} />
		</div>
	);
};

export default React.memo(BarChart);
